import { US_STATES } from "./us";

/**
 * Subdivisions previously returned by Country State City for the US, excluding
 * Puerto Rico because the application exposes it as a separate country.
 */
export const US_SUBDIVISIONS = [
  ...US_STATES,
  { name: "American Samoa", code: "AS" },
  { name: "Armed Forces Europe", code: "AE" },
  { name: "Armed Forces of the Americas", code: "AA" },
  { name: "Armed Forces Pacific", code: "AP" },
  { name: "District of Columbia", code: "DC" },
  { name: "Guam", code: "GU" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "United States Minor Outlying Islands", code: "UM" },
  { name: "United States Virgin Islands", code: "VI" },
] as const;
